<template>
  <div>
    <v-chip v-if="dateFilters.length > 0"
            class="mr-4"
            closable
            close-icon="fal fa-xmark"
            @click:close="removeDateFilters"
    >
      <span class="mr-1 text--x-small text--bold" >
        {{ $t("common.date") }} :
      </span>
      <span class="text--x-small">
        {{ dateFilters }}
      </span>
    </v-chip>
    <v-chip v-if="filters.signatories.length > 0"
            closable
            close-icon="fal fa-xmark"
            @click:close="setFiltersSignatories([])"
    >
      <span class="mr-1 text--x-small text--bold" >
        {{ $t("common.signer") }} :
      </span>
      <span class="text--x-small">
        {{ $t("common.selectedItems", filters.signatories.length) }}
      </span>
    </v-chip>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { ISOToShortenedDate } from '@/common/utils/dates'

export default {
  name: 'SignedDocumentsHeaderFilters',
  computed: {
    ...mapState('signedDocuments', ['filters']),
    dateFilters () {
      const dateFilters = []

      if (this.filters.startDate) {
        dateFilters.push(ISOToShortenedDate(this.filters.startDate))
      }

      if (this.filters.endDate) {
        dateFilters.push(ISOToShortenedDate(this.filters.endDate))
      }

      return dateFilters.join(' - ')
    },
  },
  methods: {
    ...mapActions('signedDocuments', ['setFiltersStartDate', 'setFiltersEndDate', 'setSignDateModel', 'setFiltersSignatories']),
    removeDateFilters () {
      this.setFiltersStartDate(null)
      this.setFiltersEndDate(null)
    },
  },
}
</script>
